import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const NotFound = () => {
    let history = useHistory();

    useEffect(() => {
        history.push("/");
    }, []);

    return (
        <div>
            <h1>404 Not Found</h1>
        </div>
    );
}

export default NotFound;